import { OnInit, OnDestroy, Component, Input } from '@angular/core'
import { Subscription } from 'rxjs/Subscription'

import { Message } from '../../../core/models'
import { MessageService } from '../../../core/services'

const DEFAULT_MESSAGE_BSTRAP_CLASS = 'info'
const MESSAGE_CATEGORY_BSTRAP_CLASS_MAPPING = {
  success: 'success',
  warning: 'warning',
  error: 'danger',
  info: 'info'
}

@Component({
  selector: 'mp-flash-message',
  templateUrl: './flash-message.html'
})
export class FlashMessageComponent implements OnInit, OnDestroy {

  @Input() public dismissable: boolean = true
  @Input() public timeout: number = 5

  public messages: Message[]

  private _messageSubscription: Subscription

  constructor(private _messageService: MessageService) {
    this.messages = []
  }

  public ngOnInit() {
    const messageEmitter = this._messageService.onMessageReceived()
    this._messageSubscription = messageEmitter.subscribe((message) => this.handleMessageReceived(message))
  }

  public ngOnDestroy() {
    this._messageSubscription.unsubscribe()
  }

  public alertCategoryCssClass(message: Message) {
    const alertSuffix = MESSAGE_CATEGORY_BSTRAP_CLASS_MAPPING[message.category] || DEFAULT_MESSAGE_BSTRAP_CLASS

    return `alert-${alertSuffix}`
  }

  public onMessageDismissed(message) {
    this.removeMessage(message)
  }

  private handleMessageReceived(message: Message) {
    this.messages.unshift(message)

    if (this.timeout > 0) {
      setTimeout(() => {
        this.removeMessage(message)
      }, this.timeout * 1000)
    }
  }

  private removeMessage(message: Message) {
    this.messages = this.messages.filter((msg) => msg !== message)
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/flash-message/flash-message.component.ts